"use client";

import { Button } from "@chakra-ui/react";
import { useRouter } from "next/navigation";
import { useLoading } from "@/app/context/LoadingProvider";

export function LandingStartButton() {
  const router = useRouter();
  const { setPageLoading } = useLoading();

  const handleStart = () => {
    setPageLoading(true);
    router.replace("/SignUp");
  };

  return (
    <Button
      onClick={handleStart}
      variant="surface"
      colorPalette="cyan"    
    >
      Start Your Free Journey
    </Button>
  );
}
